import { SET_VEHICLE_TYPE } from '../actions/types';

export default function vehicleType(state = '', action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_VEHICLE_TYPE:
				return action.payload;

			// no default
		}
	}

	return state;
}
